<template>
    <div class="header">
        <div class="content">
            
            <div class="logo">
                <img src="../../../assets/images/bamei/logo.png">
            </div>
            <div class="right">
                <div class="top">
                    <div class="language">
                        <span :class="{'on' : Selectlanguage=='chinese'}" @click="goto('chinese')">中文</span>
                        <span :class="{'on' : Selectlanguage=='English'}" @click="goto('English')">English</span>
                    </div>
                    <HeaderBar :width="pageWidth" :bgColor="bgColor" v-if="!isEnglish"
                    :registerTextColor='registerTextColor' :loginTextColor="loginTextColor"></HeaderBar>
                   
                </div>
                <div class="nav" v-if="!isEnglish">
               <div
                class="tab-item"
                v-for="item in tabList"
                :key="item.value"
                :class="{on: item.routeName === value}"
                @click="onTabClick(item)"
            >
                 
                {{ item.label }}
                <em v-if="item.routeName === value"> <img src="../../../assets/images/bamei/nav_on.png"></em>
            </div>
            </div>
            </div>
            
        </div>
        
    </div>
</template>
<script>
import { apiGet } from "@/fetch/api";

import { mapState } from "vuex";
import HeaderBar from "@/components/headerBar";

export default {
    props: {
        tabList: {
        type: Array,
        default: () => []
        },
        value: {
        type: String,
        default: "home"
        },
        isEnglish:{
        type: Boolean,
        default: false
        },
        Selectlanguage:{
        type: String,
        default: "chinese"
        }
    },
     components: {
       HeaderBar,
      
    },
    data() {
    return {
      current: "",
      showLoginModel:false,
      pageWidth:166,
      bgColor:'',
      registerTextColor:'#126c42',
      loginTextColor:'#333',
     };
  },
  computed: {
    ...mapState(["login", "userInfo", "m_id",''])
  },
  mounted(){
  
   
  },
    methods: {
        
        onTabClick(data) {
           if (data.value === this.value) {
                return;
            }
            this.$emit("change", data);
        },
        loginChange(bool, isLoginRegister) {
           this.$parent.loginChange(bool, isLoginRegister)
        },
         goto(type){
            if(type==='chinese'){
                this.$router.push('/index?m_id='+(localStorage.getItem('m_id')||this.$route.query.m_id));
                localStorage.setItem('selectValue','bameiHomePage');
            }
            if(type==='English'){
                this.$router.push('/Eindex?m_id='+(localStorage.getItem('m_id')||this.$route.query.m_id));
             }
            this.$emit("lang", type);
        }
    
    }
  
}
</script>
<style scoped lang="scss">
.header{
    width: 100%;
    height: 152px;
    position: fixed;
    top: 0;
    z-index: 4;
   
  .content{
    width: 1060px;
    margin: 0 auto;
    display: flex;
    .logo{
        width: 128px;
        height: 152px;
        
        margin-right: 20px;
    }
    .right{
        width: 100%;
        height: 152px;
        .top{
            width: 100%;
            text-align: right;
            color: #333;
            margin-top: 10px;
            display: flex;
            flex-direction: row-reverse;
          .header-top-bar{
             width: 166px; 
             height: auto;
          }  
         .login{
             cursor: pointer;
         } 
         .regsiter{
            cursor: pointer;
            color:#126c42 ;
            padding-left: 20px;
         } 
         
        }
    }
    .language{
        clear: both;
        span{
            text-align: center;
            line-height: 22px;
            display: block;
            float: left;
            width: 54px;
            cursor: pointer;
            height: 22px;
            border: 1px solid #126c42;
         }
         .on{
            color: #fff;
            background:#126c42;
         }   
    }
    .nav{
       display: flex;
       height: 118px;
       .tab-item{
           width: 182px;
           text-align: center;
           color: #333;
           font-size: 18px;
           margin-top: 50px;
           cursor: pointer;
           em{
               display: block;
               width: 48px;
               height: 7px;
               margin: 0 auto;
               margin-top: 10px;
           }
        }
        .on{
               color: #126c42;
               font-size: 20px;
           }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/bamei/components/header.vue